import type { ReactNode } from 'react';
import * as Sentry from '@sentry/react';
import { AlertCircle, RefreshCw } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface ErrorBoundaryProps {
  children: ReactNode;
}

function ErrorFallback() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-[#F7FBF9] p-6">
      <div className="w-full max-w-lg rounded-3xl border border-[#E4EFE9] bg-white p-8 text-center shadow-[0_24px_60px_-32px_rgba(15,23,42,0.28)]">
        <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-2xl bg-[rgba(88,189,179,0.12)] text-[#2A3B34]">
          <AlertCircle className="h-6 w-6" />
        </div>
        <h1 className="text-2xl font-bold text-[#2A3B34]">Algo salió mal</h1>
        <p className="mt-3 text-sm leading-6 text-[#5F766B]">
          Algo salió mal. Nuestro equipo fue notificado.
        </p>
        <Button
          onClick={() => window.location.reload()}
          className="mt-6 h-11 rounded-xl bg-[#2A3B34] px-5 text-sm font-semibold text-white hover:bg-[#21302A]"
        >
          <RefreshCw className="mr-2 h-4 w-4" />
          Recargar página
        </Button>
      </div>
    </div>
  );
}

export function ErrorBoundary({ children }: ErrorBoundaryProps) {
  return (
    <Sentry.ErrorBoundary fallback={<ErrorFallback />} showDialog={false}>
      {children}
    </Sentry.ErrorBoundary>
  );
}
